import type { DisplayEmployeeWithRole } from '../shared/types/one-on-one.types';
import { EmptyEmployeeState } from './EmptyEmployeeState';
import { MeetingHistoryList } from './MeetingHistoryList';

interface EmployeeMeetingHistoryProps {
  selectedEmployee: DisplayEmployeeWithRole | null;
  meetings:
    | Array<{ _id: string; schedualedDate?: string; status: string }>
    | undefined;
  isLoading: boolean;
}

export const EmployeeMeetingHistory = ({
  selectedEmployee,
  meetings,
  isLoading,
}: EmployeeMeetingHistoryProps) => {
  if (!selectedEmployee) {
    return <EmptyEmployeeState />;
  }

  return (
    <div className="flex flex-1 flex-col">
      <MeetingHistoryList meetings={meetings} isLoading={isLoading} />
    </div>
  );
};
